// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatApp_container__QPJ_V","chatContainer":"ChatApp_chatContainer__3chvI"};